import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Route } from 'app/core/route.service';
import { PreviewProcessComponent } from 'app/previewProcess/previewProcess.component';


const routes: Routes = Route.withShell([
  { path: 'process/preview/:id/:name', component:  PreviewProcessComponent, data: { titleKey: 'PROCESS.PREVIEW.PAGE_TITLE' } },
  { path: 'process/preview/:id', component:  PreviewProcessComponent, data: { titleKey: 'PROCESS.PREVIEW.PAGE_TITLE' } }
], false);

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class PreviewProcessRoutingModule { }



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/previewProcess/previewProcess-routing.module.ts